<script>
    import { url } from "@roxi/routify";
    export let showText = false;
</script>

<a href={$url("/")} class="back-btn">
    <svg
        class="back-btn__icon"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
    >
        <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5"
        />
    </svg>

    {#if showText}
        <span class="back-btn__text">Back</span>
    {/if}
</a>

<style>
    .back-btn {
        @apply flex items-center transition-all hover:-ml-2 hover:pr-2;
    }
    .back-btn__icon {
        @apply h-4 w-4 text-gray-400;
    }
    .back-btn__text {
        @apply ml-2 text-sm text-gray-400;
    }
</style>
